import {EventBroker} from "@frontend/lib/utils/event-broker";

export const COPY_PASTE_EVENTS = {
  COPY: 'COPY',
  PASTE: 'PASTE'
}

export const copyPasteEventBroker = new EventBroker();
